<template>
    <div class="banner banner-promo">
        <div
            class="banner-promo__image"
            :style="{'background-image': 'url(' + `${resizedImage}` + ')'}"
        ></div>
        <div class="banner-promo__content">
            <div class="banner-promo__content-title">
                {{ title }}
            </div>
            <div class="banner-promo__content-text">
                {{ description }}
            </div>
        </div>
        <a
            @click="$emit('click', { link, actionType })"
            class="banner-promo__content-link"
        >
            {{ linkDescription }}
            <i class="icon icon-arrow_right"/>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'PromotionBanner',
        props: {
            title: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            image: {
                type: String,
                required: true
            },
            link: {
                type: String,
                required: true
            },
            linkDescription: {
                type: String,
                required: true
            },
            actionType: {
                type: String,
                required: true
            },
        },
        computed: {
            resizedImage() {
                return this.image.replace('_960.', '_800.');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/banners/components/PromotionBanner.vue